import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'

const Border = styled.div`
  ${({ theme }) => `
    background-color: ${theme.palette.background.disabled};
    height: 2px;
    position: relative;
  `}
`

const SelectedBar = styled.div`
  ${({ theme, $start }) => `
    background-color: ${theme.palette.text.minus2};
    height: 2px;
    left: 0;
    width: ${$start ? '100%' : '0'};
    position: absolute;
    transition: width 5s ease-out;
  `}
`

const SelectedAnimation = () => {
  const [start, setStart] = useState(false)
  useEffect(() => {
    setTimeout(() => setStart(true))
  }, [])
  return <SelectedBar $start={start} />
}

const DesktopPaginationWithTitle = ({
  data,
  currentIndex,
  onPaginationIndexClick,
}) => {
  return (
    <Box display="flex" justifyContent="center" mt={{ md: 10 }}>
      {data?.map?.((banner, index) => (
        <Box
          onClick={() => onPaginationIndexClick(index)}
          sx={{ cursor: 'pointer' }}
        >
          <Box width="152px">
            <Border>{currentIndex === index && <SelectedAnimation />}</Border>
            <Typography
              variant="body1"
              color={
                currentIndex === index ? 'text.minus2' : 'background.disabled'
              }
              fontWeight="fontWeightBold"
              py={4}
              px={3}
              textAlign="center"
            >
              {banner.title || banner.name}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default DesktopPaginationWithTitle
